import { FormHelperText } from '@mui/material'
import React from 'react'

const FormErrorMessage: ReactFC = (props) => {
  return <FormHelperText error>{props.children}</FormHelperText>
}

export default FormErrorMessage
